<template>
  <section class="hero-outer py-4 sm:py-5" aria-labelledby="hero-heading">
    <div class="max-w-screen-xl mx-auto px-4">
      <div class="hero-grid">

        <!-- Links: gele promo-kaart -->
        <div class="hero-promo">
          <div class="hero-promo-text">
            <span class="hero-eyebrow">
              <i class="bi bi-battery-charging" aria-hidden="true"></i> Thuisbatterij
            </span>
            <h1 id="hero-heading" class="hero-title">
              Hoymiles<br>HiBattery
            </h1>
            <p class="hero-tagline">1,92 kWh · Plug &amp; Play · IP66 · 10 jr garantie</p>
            <div class="hero-price-row">
              <span class="hero-price">€&thinsp;850<span class="hero-price-dash">,–</span></span>
              <span class="hero-vat">incl. btw</span>
            </div>
            <p class="hero-excl">€&thinsp;702,48 excl. btw</p>
            <router-link
              to="/product/hoymiles-hibattery-1920-ac-sv"
              class="hero-btn"
              aria-label="Bestel Hoymiles HiBattery"
            >
              Bestel nu <i class="bi bi-arrow-right" aria-hidden="true"></i>
            </router-link>
          </div>

          <div class="hero-promo-img" aria-hidden="true">
            <img
              :src="heroImg"
              alt=""
              width="220"
              height="240"
              loading="eager"
              fetchpriority="high"
              decoding="async"
              @error="(e) => e.target.style.display='none'"
            >
          </div>
        </div>

        <!-- Rechts: USP-paneel -->
        <div class="hero-usps">
          <h2 class="hero-usps-title">Waarom Plug2Charge?</h2>
          <ul class="hero-usp-list">
            <li><i class="bi bi-check-circle-fill" aria-hidden="true"></i> Voor 15:00 besteld, morgen in huis</li>
            <li><i class="bi bi-check-circle-fill" aria-hidden="true"></i> Gratis verzending vanaf €50</li>
            <li><i class="bi bi-check-circle-fill" aria-hidden="true"></i> 2 jaar garantie op alle producten</li>
            <li><i class="bi bi-check-circle-fill" aria-hidden="true"></i> 30 dagen retour, niet goed geld terug</li>
            <li><i class="bi bi-check-circle-fill" aria-hidden="true"></i> A-merken uit eigen voorraad</li>
          </ul>

          <div class="hero-rating" aria-label="Google beoordeling: 4,9 van 5">
            <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
              <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
              <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
              <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
            </svg>
            <span class="hero-rating-score">4,9</span>
            <span class="hero-rating-stars" aria-hidden="true">★★★★★</span>
            <span class="hero-rating-label">Google beoordeling</span>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script setup>
const heroImg = 'https://www.elektramat.nl/media/catalog/product/H/i/HiBattery-2-png_1.png'
</script>

<style scoped>
/* ── Grid: geel 1fr + USP-paneel 300px ──────────────────────────────────── */
.hero-grid {
  display: grid;
  grid-template-columns: 1fr 300px;
  gap: 12px;
  align-items: stretch;
}

/* ── Gele promo-kaart ───────────────────────────────────────────────────── */
.hero-promo {
  background: #FFD500;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  min-height: 280px;
  position: relative;
}

.hero-promo-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2rem 1.75rem;
  z-index: 1;
}

.hero-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #7a5f00;
  margin-bottom: 0.6rem;
}

.hero-title {
  font-size: clamp(1.6rem, 2.5vw, 2rem);
  font-weight: 800;
  color: #111;
  line-height: 1.1;
  letter-spacing: -0.02em;
  margin: 0 0 0.5rem;
}

.hero-tagline {
  font-size: 0.8rem;
  font-weight: 600;
  color: #5a4100;
  margin: 0 0 0.85rem;
}

.hero-price-row {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  margin-bottom: 0.15rem;
}

.hero-price {
  font-size: clamp(1.75rem, 3vw, 2.25rem);
  font-weight: 800;
  color: #111;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.02em;
  line-height: 1;
}

.hero-price-dash {
  font-size: 1.25rem;
}

.hero-vat {
  font-size: 0.7rem;
  font-weight: 600;
  color: #5a4100;
  background: rgba(0,0,0,0.09);
  padding: 0.2em 0.5em;
  border-radius: 4px;
}

.hero-excl {
  font-size: 0.72rem;
  color: #7a5f00;
  margin: 0 0 1.25rem;
}

.hero-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: #111;
  color: #fff;
  font-weight: 700;
  font-size: 0.875rem;
  padding: 0.6rem 1.2rem;
  border-radius: 7px;
  text-decoration: none;
  align-self: flex-start;
  transition: background 150ms cubic-bezier(0.23, 1, 0.32, 1),
              transform  150ms cubic-bezier(0.23, 1, 0.32, 1);
}
.hero-btn:hover  { background: #333; transform: translateY(-1px); }
.hero-btn:active { background: #111; transform: scale(0.98); }

/* Productfoto: rechts in de kaart, bottomed */
.hero-promo-img {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 1rem 1.5rem 0 0;
  flex-shrink: 0;
  width: 200px;
}

.hero-promo-img img {
  max-height: 230px;
  max-width: 190px;
  width: 100%;
  object-fit: contain;
  filter: drop-shadow(0 6px 20px rgba(0,0,0,0.12));
}

/* ── USP-paneel ─────────────────────────────────────────────────────────── */
.hero-usps {
  background: #fdf8ec;
  border-radius: 12px;
  padding: 1.5rem 1.25rem;
  display: flex;
  flex-direction: column;
}

.hero-usps-title {
  font-size: 0.875rem;
  font-weight: 800;
  color: #111;
  margin: 0 0 1rem;
}

.hero-usp-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  flex: 1;
}

.hero-usp-list li {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  font-size: 0.78rem;
  color: #444;
  line-height: 1.4;
}

.hero-usp-list i {
  color: #FFD500;
  flex-shrink: 0;
  margin-top: 0.1em;
}

/* Google-rating */
.hero-rating {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-top: 1rem;
  padding-top: 0.85rem;
  border-top: 1px solid #e8dfc0;
}

.hero-rating-score {
  font-size: 0.875rem;
  font-weight: 800;
  color: #111;
  font-variant-numeric: tabular-nums;
}

.hero-rating-stars {
  color: #FBBC05;
  font-size: 0.7rem;
  letter-spacing: 0.05em;
}

.hero-rating-label {
  font-size: 0.68rem;
  color: #888;
}

/* ── Motion ─────────────────────────────────────────────────────────────── */
@media (prefers-reduced-motion: no-preference) {
  .hero-promo { animation: heroIn 0.4s cubic-bezier(0.22, 1, 0.36, 1) both; }
  .hero-usps  { animation: heroIn 0.4s cubic-bezier(0.22, 1, 0.36, 1) 0.07s both; }

  @keyframes heroIn {
    from { opacity: 0; transform: translateY(10px); }
    to   { opacity: 1; transform: translateY(0); }
  }
}

/* ── Tablet ─────────────────────────────────────────────────────────────── */
@media (max-width: 820px) {
  .hero-grid {
    grid-template-columns: 1fr 260px;
  }
  .hero-promo-img { width: 160px; }
  .hero-promo-img img { max-height: 190px; }
}

/* ── Mobiel ─────────────────────────────────────────────────────────────── */
@media (max-width: 600px) {
  .hero-grid {
    grid-template-columns: 1fr;
  }

  .hero-promo {
    min-height: auto;
  }

  .hero-promo-img {
    width: 130px;
    padding: 0.75rem 1rem 0 0;
  }

  .hero-promo-img img {
    max-height: 150px;
  }

  .hero-usps {
    display: none; /* op mobiel weggelaten — niet genoeg ruimte */
  }
}
</style>
